<template>
  <div>
    <div class="container">
      <e-search
        :data="filterInfo.data"
        :field-list="filterInfo.filterList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleQuery"
        @handleReset="handleReset"
      ></e-search>
    </div>

    <div class="container">
      <div class="button-box">
        <eui-btn type="primary" @click="handleApply">批量申请</eui-btn>
      </div>
      <eTableList
        :table-data="tableData"
        :table-label="tableLabel"
        :selection-show="true"
        :row-key="rowKey"
        :check-selectable="checkSelectable"
        @handleSelectionChange="handleSelectionChange"
      >
        <template #indexSlot="slot">
          <div class="flex-center-center">{{ slot.scope.$index + 1 }}</div>
        </template>
        <template #roleStatusSlot="slot">
          <div v-if="slot.scope.row.roleStatus === 1">已拥有</div>
          <div v-if="slot.scope.row.roleStatus === 2">申请中</div>
          <div v-if="slot.scope.row.roleStatus === 3">未拥有</div>
        </template>
        <template #optionsSlot="slot">
          <eui-btn
            type="link"
            size="12"
            color="#0064c8,#004898,#004898"
            @click="handleView(slot.scope.row)"
            >查看</eui-btn
          >
          <eui-btn
            v-if="slot.scope.row.roleStatus === 3"
            type="link"
            size="12"
            color="#0064c8,#004898,#004898"
            @click="handleEdit(slot.scope.row)"
            >申请</eui-btn
          >
        </template>
      </eTableList>
      <div class="pagination">
        <el-pagination
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="productTagPage.pageStart"
          :page-size="productTagPage.pageSize"
          :total="productTagPage.pageTotal"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <FormDialog ref="applyDialog" @getList="getList"></FormDialog>
    <RoleDialog
      v-if="checkRoleDialogShow"
      :role-data="roleData"
      :visible="checkRoleDialogShow"
      @close="closeCheckRole"
    ></RoleDialog>
  </div>
</template>

<!-- <e-tooltip :content="scope.row.purchaseCompany" :set-length="20" /> -->
<!-- import eTooltip from '../../components/common/e-tooltip'; -->
<script>
import eTableList from '@/modules/projectA/components/common/e-table-list';
import FormDialog from './components/roleApplyDialog.vue';
import RoleDialog from './components/checkRoleDialog.vue';
import Api from '../../api/authority';
import { roleApply } from './roleApply';
import eSearch from '../../components/common/e-search';

export default {
  name: 'RoleApply',
  components: {
    FormDialog,
    RoleDialog,
    eTableList,
    eSearch,
  },
  props: {},
  data() {
    return {
      roleApply,
      query: {
        roleName: null,
        remark: null,
        roleStatus: null,
      },
      filterInfo: roleApply.filterInfo,
      listTypeInfo: roleApply.listTypeInfo,
      tableData: [],
      tableLabel: roleApply.tableLabel,
      productTagPage: {
        pageStart: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      roleData: {},
      rowKey: 'roleId',
      selectionData: [],
      checkRoleDialogShow: false,
      checkedAll: false,
    };
  },
  computed: {},
  created() {
    this.getList();
  },
  methods: {
    checkSelectable(row) {
      if (this.checkedAll) {
        return false;
      }
      if (row.roleStatus === 3) {
        return true;
      }

      return false;
    },
    closeCheckRole() {
      this.checkRoleDialogShow = false;
    },
    handleSelectionChange(val) {
      this.selectionData = [...val];
    },
    // 搜索
    handleQuery(val) {
      this.query = val;
      this.productTagPage.pageStart = 1;
      this.productTagPage.pageSize = 10;
      this.productTagPage.pageTotal = 0;
      this.getList();
    },
    // 重置
    handleReset() {
      this.query = {
        roleName: null,
        remark: null,
        roleStatus: null,
      };
      this.productTagPage.pageStart = 1;
      this.productTagPage.pageSize = 10;
      this.productTagPage.pageTotal = 0;
      this.getList();
    },

    // 批量申请
    handleApply() {
      if (this.selectionData.length > 0) {
        const object = this.$refs.applyDialog;
        object.initData(this.selectionData);
      } else {
        this.$message.warning('请选择要申请的角色');
      }
    },
    // 申请
    handleEdit(row) {
      console.log(row);
      const object = this.$refs.applyDialog;
      object.initData([row]);
    },
    // 查看
    handleView(row) {
      console.log(row);
      this.checkRoleDialogShow = true;
      this.roleData = row;
    },

    // 获得列表
    getList() {
      const params = this.query;
      // params.companyId = JSON.parse(localStorage.getItem('USERINFO')).companyId;
      params.pageSize = this.productTagPage.pageSize;
      params.pageStart = this.productTagPage.pageStart;

      Api.queryApplyPage(params).then((res) => {
        this.tableData = res.data?.list;
        this.productTagPage.pageTotal = res.data.total;
      });
    },
    // 更改页码
    handleCurrentChange(val) {
      this.productTagPage.pageStart = val;
      this.getList();
    },

    // 更改条数
    handleSizeChange(val) {
      this.productTagPage.pageStart = 1;
      this.productTagPage.pageSize = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  .text-box {
    padding: 11px 10px;
    background: #f4f7ff;
    font-size: 14px;
    font-style: normal;
    font-weight: 350;
    line-height: 24px;
    color: #666;
    margin-top: 10px;
    text-align: center;
  }
  .button-box {
    padding-bottom: 10px;
    margin-top: 10px;
  }
}
</style>
